import { computed, Injectable, signal } from '@angular/core';
import { IViewMedia } from '../models/view-media.models';

@Injectable({
	providedIn: 'root',
})
export class ViewMediaService {
	private viewMediaSignal = signal<IViewMedia>(null);
	public viewMedia = computed(() => this.viewMediaSignal());

	constructor() {}

	public setViewMedia(value: IViewMedia): void {
		this.viewMediaSignal.set(value);
	}

	public hide(): void {
		this.viewMediaSignal.set({
			show: false,
			title: '',
			tag: {
				label: '',
				status: 'error',
			},
			subtitle: '',
			activity: null,
			downloadFileName: null,
			developerCurl: null,
			data: [],
		});
	}
}
